<script>
const LangListAPI = "https://ams4you.net/amsapi/public/websearch/GetLangLanguageList";
const LangChangeAPI = "https://ams4you.net/amsapi/public/websearch/GetLangLanguageChange";

import axios from "axios";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
export default {
    components: {
        Datepicker,
    },
    data() {
        return {
            query: "",
            SelLang: {},
            SelCountry: {},
            SelWeek: {
                Id: "",
                Name: "",
            },
            SelDate: "",
            LanguageList: [],
            CountryList: [],
        };
    },
    computed: {
        WeekList() {
            let list = [];
            for (let i = 1; i <= 52; i++) {
                list.push({
                    Id: i,
                    Name: i == 1 ? i + " week" : i + " weeks",
                });
            }
            return list;
        },
        Setting() {
            return this.$parent.Setting;
        },
        Translation() {
            return this.$parent.Translation;
        },
        SetDataStep() {
            if (this.SelWeek?.Id) {
                return 4;
            }
            if (this.SelCountry?.Id) {
                return 3;
            }
            if (this.SelLang?.LanguageId) {
                return 2;
            }
            return 1;
        },
        LanguageSelected() {
            if (!this.SelWeek?.Id) return false;
            if (!this.SelCountry?.Id) return false;
            if (!this.SelLang?.LanguageId) return false;
            if (!this.SelDate) return false;

            return true;
        },
    },
    watch: {
        SelLang(val) {
            this.SelCountry = {
                Id: 0,
                Name: this.Translation.SelectCountry,
            };
            this.LanguageList.CountryList = [];
            if (val?.LanguageId) {
                let LatestQuery = this.query + "&LanguageId=" + val.LanguageId;
                this.GetCountries(LatestQuery);
            }
        },
    },
    methods: {
        MakeSearch() {
            let Path = "https://my.alternatifecs.com/search/language";

            let query = "?CountryId=" + this.SelCountry.Id + "&LevelId=" + this.SelLang.LanguageId + "&Weeks=" + this.SelWeek.Id + "&StartDate=" + moment(this.SelDate).format("YYYY-MM-DD");
            window.open(Path + query, this.Setting.OpenInNewWindow ? "_blank" : "_self");
        },
        async GetLanguageList() {
            let ag = this.$parent.ag;
            let wid = this.$parent.wid;
            this.query = "?ag=" + ag + "&wfid=" + wid;
            const request = await axios.get(LangListAPI + this.query);
            const response = request.data;
            this.LanguageList = response.detail;
        },
        async GetCountries(Query) {
            const request = await axios.get(LangChangeAPI + Query);
            const response = request.data;
            this.CountryList = response.detail;
        },
        ClearAll() {
            this.SelLang = {};
            this.SelCountry = {};
            this.SelWeek = {
                Id: "",
                Name: "",
            };
            this.SelDate = "";
        },
    },
    mounted() {
        this.GetLanguageList();
        this.SelDate = new Date(moment().add(1, "month").toJSON());
    },
};
</script>
<template>
    <div
        class="card-type"
        :class="{
            active: LanguageSelected,
        }"
    >
        <div class="card-type-head">
            <svg width="100" height="90" viewBox="0 0 245 233" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink: 0">
                <path d="M221 4V36L213 28L205 36V4H221Z" fill="#FFBDBD" />
                <path d="M221 64H205V72H221V64Z" fill="#EF4136" />
                <path d="M177 160.76V188L165 180L153 188V160.76C156.643 162.882 160.784 163.999 165 163.999C169.216 163.999 173.357 162.882 177 160.76Z" fill="#FFBDBD" />
                <path d="M165 152C171.627 152 177 146.627 177 140C177 133.373 171.627 128 165 128C158.373 128 153 133.373 153 140C153 146.627 158.373 152 165 152Z" fill="#FFBDBD" />
                <path
                    d="M233 0H97C93.8174 0 90.7652 1.26428 88.5147 3.51472C86.2643 5.76516 85 8.8174 85 12V76H93V12C93 10.9391 93.4214 9.92172 94.1716 9.17157C94.9217 8.42143 95.9391 8 97 8H201V36C201 36.791 201.235 37.5642 201.674 38.2218C202.114 38.8795 202.739 39.392 203.469 39.6947C204.2 39.9974 205.004 40.0766 205.78 39.9223C206.556 39.7681 207.269 39.3872 207.828 38.828L213 33.656L218.172 38.828C218.731 39.3872 219.444 39.7681 220.22 39.9223C220.996 40.0766 221.8 39.9974 222.531 39.6947C223.261 39.392 223.886 38.8795 224.326 38.2218C224.765 37.5642 225 36.791 225 36V8H233C234.061 8 235.078 8.42143 235.828 9.17157C236.579 9.92172 237 10.9391 237 12V204C237 205.061 236.579 206.078 235.828 206.828C235.078 207.579 234.061 208 233 208H149V216H233C236.183 216 239.235 214.736 241.485 212.485C243.736 210.235 245 207.183 245 204V12C245 8.8174 243.736 5.76516 241.485 3.51472C239.235 1.26428 236.183 0 233 0ZM217 26.344L215.828 25.172C215.078 24.4221 214.061 24.0009 213 24.0009C211.939 24.0009 210.922 24.4221 210.172 25.172L209 26.344V8H217V26.344Z"
                    fill="#EF4136"
                />
                <path d="M197 64H109V72H197V64Z" fill="#EF4136" />
                <path d="M221 80H109V88H221V80Z" fill="#EF4136" />
                <path d="M181 40H149V48H181V40Z" fill="#EF4136" />
                <path d="M173 24H157V32H173V24Z" fill="#EF4136" />
                <path
                    d="M165 156C168.165 156 171.258 155.062 173.889 153.304C176.52 151.545 178.571 149.047 179.782 146.123C180.993 143.199 181.31 139.982 180.693 136.879C180.075 133.775 178.551 130.924 176.314 128.686C174.076 126.449 171.225 124.925 168.121 124.307C165.018 123.69 161.801 124.007 158.877 125.218C155.953 126.429 153.455 128.48 151.696 131.111C149.938 133.742 149 136.836 149 140C149 144.243 150.686 148.313 153.686 151.314C156.687 154.314 160.757 156 165 156ZM165 132C166.582 132 168.129 132.469 169.445 133.348C170.76 134.227 171.786 135.477 172.391 136.939C172.997 138.4 173.155 140.009 172.846 141.561C172.538 143.113 171.776 144.538 170.657 145.657C169.538 146.776 168.113 147.538 166.561 147.846C165.009 148.155 163.4 147.997 161.939 147.391C160.477 146.786 159.227 145.76 158.348 144.445C157.469 143.129 157 141.582 157 140C157 137.878 157.843 135.843 159.343 134.343C160.843 132.843 162.878 132 165 132Z"
                    fill="#EF4136"
                />
                <path
                    d="M149 188C149 188.724 149.196 189.435 149.568 190.056C149.941 190.677 150.474 191.186 151.113 191.528C151.751 191.869 152.471 192.031 153.194 191.996C153.917 191.961 154.618 191.73 155.22 191.328L165 184.8L174.78 191.32C175.382 191.722 176.081 191.952 176.804 191.988C177.527 192.023 178.245 191.862 178.884 191.521C179.522 191.181 180.056 190.673 180.428 190.053C180.801 189.433 180.999 188.724 181 188V162.944C185.892 159.538 189.569 154.659 191.496 149.018C193.424 143.377 193.5 137.269 191.715 131.581C189.93 125.894 186.376 120.924 181.571 117.396C176.767 113.868 170.961 111.966 165 111.966C159.039 111.966 153.233 113.868 148.429 117.396C143.624 120.924 140.07 125.894 138.285 131.581C136.5 137.269 136.576 143.377 138.504 149.018C140.431 154.659 144.108 159.538 149 162.944V188ZM173 180.524L167.22 176.672C166.563 176.234 165.79 175.999 165 175.999C164.21 175.999 163.437 176.234 162.78 176.672L157 180.524V166.82C162.217 168.393 167.783 168.393 173 166.82V180.524ZM145 140C145 136.044 146.173 132.178 148.371 128.889C150.568 125.6 153.692 123.036 157.346 121.522C161.001 120.009 165.022 119.613 168.902 120.384C172.781 121.156 176.345 123.061 179.142 125.858C181.939 128.655 183.844 132.219 184.616 136.098C185.387 139.978 184.991 143.999 183.478 147.654C181.964 151.308 179.4 154.432 176.111 156.629C172.822 158.827 168.956 160 165 160C159.698 159.994 154.614 157.885 150.865 154.135C147.116 150.386 145.006 145.302 145 140Z"
                    fill="#EF4136"
                />
                <path d="M76.7211 225.3V227.867C76.7211 229.284 75.4943 230.433 73.9811 230.433H63.0212C61.508 230.433 60.2812 229.284 60.2812 227.867V181.667H76.7211V225.3Z" fill="#FFBDBD" />
                <path
                    d="M126.038 217.6V225.3H76.7188V184.233C76.7188 179.981 80.3989 176.533 84.9387 176.533H126.038V186.8H123.298C120.281 186.821 117.841 189.107 117.818 191.933C117.827 194.765 120.276 197.058 123.298 197.067C120.281 197.088 117.841 199.374 117.818 202.2C117.827 205.032 120.276 207.325 123.298 207.333C120.281 207.354 117.841 209.64 117.818 212.467C117.827 215.298 120.276 217.592 123.298 217.6H126.038Z"
                    fill="#FFBDBD"
                />
                <path d="M117.819 168.833V176.533H84.9398C80.4001 176.533 76.7199 179.981 76.7199 184.233V181.667H68.5V179.1C68.5 173.43 73.4069 168.833 79.4599 168.833H117.819Z" fill="#FFBDBD" />
                <path
                    d="M22.0019 176.533H19.1797V168.833H57.5393C63.5922 168.833 68.4991 173.43 68.4991 179.1V181.667H60.2792V184.233C60.2792 179.981 56.599 176.533 52.0593 176.533H22.0019Z"
                    fill="#FFBDBD"
                />
                <path
                    d="M19.1808 176.533H52.0605C56.6002 176.533 60.2804 179.981 60.2804 184.233V225.3H10.9609V217.6H13.7009C16.7236 217.592 19.1718 215.298 19.1808 212.467C19.1585 209.64 16.7181 207.354 13.7009 207.333C16.7236 207.325 19.1718 205.032 19.1808 202.2C19.1585 199.374 16.7181 197.088 13.7009 197.067C16.7236 197.058 19.1718 194.765 19.1808 191.933C19.1585 189.107 16.7181 186.821 13.7009 186.8H10.9609V176.533H19.1808Z"
                    fill="#FFBDBD"
                />
                <path
                    d="M95.8931 107.234V117.5H91.701C87.5517 117.491 83.7601 115.298 81.8919 111.828L79.4533 107.234L78.1107 108.491C71.9479 114.262 63.5898 117.503 54.8758 117.5H41.0938V107.234C41.0938 93.0582 53.361 81.5669 68.4934 81.5669C83.6259 81.5669 95.8931 93.0582 95.8931 107.234Z"
                    fill="#FFBDBD"
                />
                <path
                    d="M134.862 197.067C137.051 194.818 137.614 191.57 136.296 188.789C134.977 186.007 132.028 184.22 128.779 184.233V176.533C128.779 175.116 127.553 173.967 126.039 173.967H120.559V168.833C120.559 167.416 119.333 166.267 117.819 166.267H113.046C110.622 163.605 107.411 161.675 103.818 160.72L82.1998 154.134V147.394C90.6661 142.815 95.8867 134.358 95.8997 125.2V120.067C97.4129 120.067 98.6397 118.918 98.6397 117.5V107.233C98.6397 91.6405 85.1457 79 68.5 79C51.8543 79 38.3603 91.6405 38.3603 107.233V117.5C38.3603 118.918 39.5871 120.067 41.1003 120.067V125.2C41.1133 134.358 46.3339 142.815 54.8002 147.394V154.137L33.2941 160.689C29.66 161.641 26.4092 163.583 23.9536 166.267H19.1805C17.6673 166.267 16.4406 167.416 16.4406 168.833V173.967H10.9606C9.44741 173.967 8.22067 175.116 8.22067 176.533V184.233C4.97213 184.22 2.02258 186.007 0.704328 188.789C-0.613954 191.57 -0.0513554 194.818 2.13794 197.067C-0.71177 199.968 -0.71177 204.432 2.13794 207.333C-0.0513828 209.582 -0.613954 212.83 0.704328 215.611C2.02261 218.393 4.97213 220.18 8.22067 220.167V225.3C8.22067 226.718 9.44741 227.867 10.9606 227.867H57.5401C57.5401 230.702 59.9936 233 63.0201 233H73.9799C77.0064 233 79.4599 230.702 79.4599 227.867H126.039C127.553 227.867 128.779 226.718 128.779 225.3V220.167C132.028 220.18 134.977 218.393 136.296 215.611C137.614 212.83 137.051 209.582 134.862 207.333C137.712 204.432 137.712 199.968 134.862 197.067ZM120.559 202.2C120.559 200.782 121.786 199.633 123.299 199.633H128.779C130.293 199.633 131.519 200.782 131.519 202.2C131.519 203.618 130.293 204.767 128.779 204.767H123.299C121.786 204.767 120.559 203.618 120.559 202.2ZM131.519 191.933C131.519 193.351 130.293 194.5 128.779 194.5H123.299C121.786 194.5 120.559 193.351 120.559 191.933C120.559 190.516 121.786 189.367 123.299 189.367H128.779C130.293 189.367 131.519 190.516 131.519 191.933ZM115.079 173.967H84.9398C81.0419 173.978 77.4459 175.934 75.5034 179.1H71.24C71.24 174.847 74.9202 171.4 79.4599 171.4H115.079V173.967ZM43.8403 107.233C43.8403 94.4756 54.8808 84.1333 68.5 84.1333C82.1192 84.1333 93.1597 94.4756 93.1597 107.233V114.933H91.713C88.5969 114.944 85.7458 113.293 84.3617 110.678L81.9259 106.086C81.5317 105.347 80.7822 104.832 79.912 104.7C79.7626 104.677 79.6113 104.666 79.4599 104.667C78.7333 104.667 78.0364 104.937 77.5227 105.419L76.1938 106.664C70.5535 111.976 62.8783 114.954 54.8796 114.933H43.8403V107.233ZM46.5802 125.2V120.067H54.8796C63.6736 120.091 72.1616 117.044 78.6872 111.522L79.4599 112.972C81.5651 116.934 85.7146 119.588 90.4198 119.982V125.2C90.4198 136.54 80.606 145.733 68.5 145.733C56.394 145.733 46.5802 136.54 46.5802 125.2ZM68.5 150.867C71.2883 150.867 74.0603 150.468 76.7199 149.683V156C76.7199 156.639 73.8046 158.567 68.5 158.567C63.1954 158.567 60.2801 156.639 60.2801 156V149.683C62.9397 150.468 65.7117 150.867 68.5 150.867ZM34.8778 165.602L55.9756 159.185C58.0361 161.903 62.7461 163.7 68.5 163.7C74.2539 163.7 78.9639 161.903 81.0408 159.18L102.235 165.633C102.863 165.805 103.478 166.017 104.076 166.267H79.4599C75.1309 166.278 71.0642 168.212 68.5 171.48C65.9358 168.212 61.8691 166.278 57.5401 166.267H32.9352C33.5657 166.004 34.2147 165.781 34.8778 165.602ZM21.9205 171.4H57.5401C62.0798 171.4 65.76 174.847 65.76 179.1H61.4966C59.5541 175.934 55.9581 173.978 52.0602 173.967H21.9205V171.4ZM8.22067 189.367H13.7006C15.2138 189.367 16.4406 190.516 16.4406 191.933C16.4406 193.351 15.2138 194.5 13.7006 194.5H8.22067C6.70744 194.5 5.4807 193.351 5.4807 191.933C5.4807 190.516 6.70744 189.367 8.22067 189.367ZM5.4807 202.2C5.4807 200.782 6.70744 199.633 8.22067 199.633H13.7006C15.2138 199.633 16.4406 200.782 16.4406 202.2C16.4406 203.618 15.2138 204.767 13.7006 204.767H8.22067C6.70744 204.767 5.4807 203.618 5.4807 202.2ZM5.4807 212.467C5.4807 211.049 6.70744 209.9 8.22067 209.9H13.7006C15.2138 209.9 16.4406 211.049 16.4406 212.467C16.4406 213.884 15.2138 215.033 13.7006 215.033H8.22067C6.70744 215.033 5.4807 213.884 5.4807 212.467ZM13.7006 222.733V220.167C16.9491 220.18 19.8987 218.393 21.2169 215.611C22.5352 212.83 21.9726 209.582 19.7833 207.333C22.633 204.432 22.633 199.968 19.7833 197.067C21.9727 194.818 22.5352 191.57 21.2169 188.789C19.8987 186.007 16.9491 184.22 13.7006 184.233V179.1H52.0602C55.0867 179.1 57.5401 181.398 57.5401 184.233V222.733H13.7006ZM63.0201 227.867V184.233H73.9799V227.867H63.0201ZM123.299 222.733H79.4599V184.233C79.4599 181.398 81.9133 179.1 84.9398 179.1H123.299V184.233C120.051 184.22 117.101 186.007 115.783 188.789C114.465 191.57 115.027 194.818 117.217 197.067C114.367 199.968 114.367 204.432 117.217 207.333C115.027 209.582 114.465 212.83 115.783 215.611C117.101 218.393 120.051 220.18 123.299 220.167V222.733ZM128.779 215.033H123.299C121.786 215.033 120.559 213.884 120.559 212.467C120.559 211.049 121.786 209.9 123.299 209.9H128.779C130.293 209.9 131.519 211.049 131.519 212.467C131.519 213.884 130.293 215.033 128.779 215.033Z"
                    fill="#EF4136"
                />
                <path
                    d="M79.4588 130.333H73.9789C73.9789 133.168 71.5254 135.467 68.4989 135.467C65.4725 135.467 63.019 133.168 63.019 130.333H57.5391C57.5391 136.003 62.446 140.6 68.4989 140.6C74.5519 140.6 79.4588 136.003 79.4588 130.333Z"
                    fill="#EF4136"
                />
            </svg>

            <div class="type-data">
                <h5 class="title">Dil Eğitimi</h5>
                <p class="desc">
                    Lorem, ipsum dolor sit amet consectetur adipisicing elit. Numquam perferendis quibusdam mollitia voluptatibus adipisci voluptas dolore fugiat commodi dignissimos vel!
                </p>
            </div>
        </div>
        <div class="card-type-content">
            <div class="input-group input-group-blur" :data-step="SetDataStep">
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content">
                        <label class="input-label">Dil</label>
                        <v-select
                            class="form-control"
                            :options="LanguageList"
                            :getOptionLabel="(option) => option.LanguageName || 'Dil seçiniz'"
                            label="LanguageName"
                            :clearable="false"
                            v-model="SelLang"
                            @option:selected="
                                SelWeek = {};
                                SelDate = '';
                                SelCountry = {};
                            "
                        />
                    </div>
                </div>
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content">
                        <label class="input-label">Ülke</label>
                        <v-select
                            class="form-control"
                            :options="CountryList"
                            label="Name"
                            :getOptionLabel="(option) => option.Name || 'Ülke seçiniz'"
                            :clearable="false"
                            v-model="SelCountry"
                            :disabled="!SelLang?.LanguageId"
                            @option:selected="
                                SelWeek = {};
                                SelDate = '';
                            "
                        />
                    </div>
                </div>
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content">
                        <label class="input-label">Hafta</label>
                        <v-select
                            class="form-control"
                            :options="WeekList"
                            label="Name"
                            :getOptionLabel="(option) => option.Name || 'Hafta seçiniz'"
                            :clearable="false"
                            v-model="SelWeek"
                            :disabled="!SelCountry?.Id"
                        />
                    </div>
                </div>
                <div class="input-row">
                    <div class="input-icon"></div>
                    <div class="input-content">
                        <label class="input-label">Başlangıç tarihi</label>
                        <datepicker
                            :disabled-dates="{
                                to: new Date(),
                            }"
                            v-model="SelDate"
                            :disabled="!SelWeek?.Id || !SelCountry?.Id"
                            class="form-control"
                            :editable="false"
                            placeholder="Select date"
                            :format="'dd-MM-yyyy'"
                        ></datepicker>
                    </div>
                </div>
                <div class="form-progress"></div>
            </div>
            <div class="btn-grid">
                <button type="button" class="btn btn-link" @click="ClearAll" v-if="SetDataStep > 1">
                    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M22.452 1.923a.75.75 0 0 1 0 1.06L16.14 9.296a6.814 6.814 0 0 0-1.067-1.053l6.32-6.32a.75.75 0 0 1 1.06 0ZM15.028 9.347a5.75 5.75 0 0 0-8.132 0l-.244.244 8.132 8.132.244-.244a5.75 5.75 0 0 0 0-8.132ZM1.884 12.966l3.613-2.409 8.32 8.321-2.408 3.613a.75.75 0 0 1-1.154.115L1.769 14.12a.75.75 0 0 1 .115-1.154Z"
                            fill="#fb4747"
                        />
                    </svg>
                    Seçimi Temizle
                </button>
                <button type="button" class="btn btn-data" :disabled="!LanguageSelected" @click="MakeSearch">Sonuçları gör</button>
            </div>
        </div>
    </div>
</template>
